import { CommentOutlined, EyeOutlined, LikeOutlined } from '@ant-design/icons';
import { Flex, Tooltip, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { formatNumber } from '@/lib/helpers/formatNumber';
import { formatSecondsToTime } from '@/lib/helpers/formatSecondsToTime';
import prepareDate from '@/lib/helpers/prepareDate';
import prepareImageSrc from '@/lib/helpers/prepareImageSrc';
import { IContent } from '@/ts';

const columns = [
	{
		title: 'Video',
		dataIndex: 'metaData.url',
		key: 'metaData.url',
		editable: false,
		width: 200,
		flex: true,
		// sortOrder: 'descend',
		ellipsis: true,
		render: (_: any, record: IContent) => {
			return (
				<Flex gap={8} align="center">
					{record?.metaData?.cdnThumbnailPath || record?.metaData?.thumbnail ? (
						<img
							src={prepareImageSrc(
								record?.metaData?.cdnThumbnailPath ||
									record?.metaData?.thumbnail,
							)}
							alt="Video Thumbnail"
							width={80}
							height={'auto'}
							style={{
								maxWidth: 80,
								maxHeight: 60,
								borderRadius: '4px',
							}}
						/>
					) : (
						<div
							style={{
								minWidth: 80,
								minHeight: 60,
								backgroundColor: '#f0f0f0',
								borderRadius: 4,
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<code style={{ fontSize: '10px', color: 'gray' }}>no image</code>
							<code style={{ fontSize: '10px', color: 'gray' }}>available</code>
						</div>
					)}

					<Flex vertical gap={4}>
						<Typography.Text>{record?.metaData?.title}</Typography.Text>
						<Link to={record?.metaData?.url} target="_blank">
							{record?.metaData?.url}
						</Link>

						<Flex gap={16}>
							<Typography.Text style={{ fontSize: '12px' }}>
								Posted: {prepareDate(record?.metaData?.date)}
							</Typography.Text>

							<Typography.Text style={{ fontSize: '12px' }}>
								Duration:{' '}
								{formatSecondsToTime(Number(record?.metaData?.duration) || 0)}
							</Typography.Text>
						</Flex>
					</Flex>
				</Flex>
			);
		},
	},
	{
		title: 'Stats',
		dataIndex: 'metaData.stats',
		key: 'metaData.stats',
		width: 70,

		// ellipsis: true,
		render: (_: any, record: IContent) => {
			return (
				<Flex gap={30} align="center" justify="flex-start">
					<Tooltip title={`Views: ${record?.metaData?.stats?.views}`}>
						<Flex gap={4}>
							<EyeOutlined /> {formatNumber(record?.metaData?.stats?.views)}
						</Flex>
					</Tooltip>

					<Tooltip title={`Likes: ${record?.metaData?.stats?.likes}`}>
						<Flex gap={4}>
							<LikeOutlined />
							{formatNumber(record?.metaData?.stats?.likes)}
						</Flex>
					</Tooltip>

					<Tooltip title={`Comments: ${record?.metaData?.stats?.comments}`}>
						<Flex gap={4}>
							<CommentOutlined />
							{formatNumber(record?.metaData?.stats?.comments)}
						</Flex>
					</Tooltip>
				</Flex>
			);
		},
	},
	{
		title: 'Posted',
		width: 70,
		dataIndex: 'posted',
		key: 'posted',
		sorter: true,
		editable: false,
		render: (_: any, record: IContent) => {
			return !record?.metaData?.date
				? '-'
				: prepareDate(record?.metaData?.date);
			// return record.;
		},
		// width: 160,
	},
	{
		title: 'Processed at',
		width: 70,
		dataIndex: 'createdAt',
		key: 'createdAt',
		sorter: true,
		editable: false,
		render: (_: any, record: IContent) => {
			return !record?.createdAt
				? '-'
				: prepareDate(record?.createdAt?.toString());
			// return record.;
		},
		// width: 160,
	},
];

export { columns };
